export default "__VITE_ASSET__BOg2i6yV__"